<template>
   <div id="wrapper">
    <div id="password-reset-component">
      <div class="bg-purple">
        <img class="logo" src="../../assets/images/logos/logo-white-live.svg" />
        <img class="page-icon" src="static/assets/icons/auth/lock.png" />
      </div>
      <div class="bg-grey text-white text-center welcome-message">
        <h4>Password Recovery</h4>
        <p>
          Sorry to hear you forgot your password. <br/>Please provide the email address for the account you wish to reset.
        </p>
      </div>
      <div class="text-center">
        <el-alert
        v-if="hasSucceeded"
        title="Success"
        type="success"
        description="Your request to reset your password has been received, please check your mailbox for details.">
      </el-alert>

      <el-alert
        v-if="hasFailed"
        title="Password Reset Failed"
        type="error"
        description="We couldn't reset your password. Please contact COLONY LIVE support for further assistance.">
      </el-alert>
        <el-form :model="passwordResetForm" :rules="passwordResetFormRules" ref="passwordResetForm" class="password-reset-form">
        <el-form-item prop="email">
          <el-input :disabled="isPending" placeholder="Email" v-model="passwordResetForm.email"></el-input>
        </el-form-item>
        <el-button id="password-reset-btn" @click="onClickResetPassword" type="primary" :loading="isPending">
          Reset Password
        </el-button>
      </el-form>
        <br>
        <strong>
          <router-link class="text-light-grey" :to="{ name: 'Login' }">Already have an account?</router-link>
        </strong>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppFooter from '@/components/app/AppFooter';

export default {
  name: 'PasswordResetForm',
  components: {
    AppFooter,
  },
  props: {
    isPending: {
      type: Boolean,
      default: false,
    },
    hasFailed: {
      type: Boolean,
      default: false,
    },
    hasSucceeded: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    passwordResetForm: {
      email: null,
    },
    passwordResetFormRules: {
      email: [
        {
          type: 'email',
          required: true,
          message: 'Please enter your email address',
          trigger: 'blur',
        },
      ],
    },
  }),
  methods: {
    onClickResetPassword() {
      this.$refs.passwordResetForm.validate(valid => {
        if (valid) {
          this.$emit('onPasswordReset', {
            email: this.passwordResetForm.email,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

#wrapper {
  background: $white;
  height: 100%;
  width: 100%;
}

#password-reset-component {
  padding-top: 10px;
  width: 300px;
  margin: 0 auto;
}

#password-reset-btn {
  width: 100%;
  background: $colony-primary;
  border-color: $colony-primary;
  border-radius: 0;
}

.logo {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0;
  display: block;
}

.page-icon {
  width: 100px;
  margin: 0 auto;
  display: block;
  padding-bottom: 20px;
}

.welcome-message {
  padding: 20px;
  margin-bottom: 20px;

  p {
    font-size: 0.7em;
    letter-spacing: 0.08em;
    line-height: 1.8em;
  }

  h4 {
    font-weight: lighter;
    font-size: 0.95em;
    margin: 0px;
    text-transform: uppercase;
    letter-spacing: 0.15em;
  }
}

.el-form {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// PasswordResetForm.vue?58d2ce4e